import { createSlice } from '@reduxjs/toolkit';

export const MAX_PROJECT_COUNT = 50;
export const PROJECT_COUNT_LIMIT_TOAST_ID = 'PROJECT_COUNT_LIMIT_TOAST_ID';

const initialState = {
  projectCount: 0,
  showSurveySuccess: false,
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setProjectCount: (state, action) => {
      state.projectCount = action.payload;
    },
    setShowSurveySuccess: (state, action) => {
      state.showSurveySuccess = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setProjectCount, setShowSurveySuccess } = homeSlice.actions;

export default homeSlice.reducer;
